import React, { ReactEventHandler, useContext, useEffect, useState, useMemo  } from "react";
import ReactDOM from "react";
import { Loading } from "../SVG";
import NoticeTable from "./NoticeTable";
import WebServiceContext from "../../webService/WebServiceContext";


type NoticeTableProps = {
    type?:string
}

type Counts= {
    [key: string]: number
}

const Notice_table= (props:NoticeTableProps) => {
    const ws = useContext(WebServiceContext)
    const [noticeData, setNoticeData] = useState<NoticeObj[]|null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    //const [THeaders, setTHeaders] = useState<string[]>([])
    const [currentSelect, setCurrentSelect] = useState<string>("%")
    const [selectsData, setSelectsData] = useState<string[]|null>()
    
    const [counts, setcounts] = useState<Counts>()
    
    useEffect(() => {
        setNoticeData(null)
        ws.webservice.asyncGetNotice("續期轉帳失敗及其他通知", currentSelect).then((res:any) => {
            if(res){
                
                setNoticeData(res as NoticeObj[])                
                if(!selectsData){
                    let _select:string[] = [currentSelect]
                    let _d:NoticeObj[] = res as NoticeObj[]
                    let _o:any={"%":_d.length} 
                    _d.map((item:NoticeObj, index:number)=>{                
                        if(_select.indexOf(item.類別)  == -1 ){
                            _select.push(item.類別)
                        }
                        if(_o[item.類別]){
                            _o[item.類別]+=1
                        }else{
                            _o[item.類別]=1
                        }

                    })
                    
                    setcounts(_o)
                    setSelectsData(_select)
                }
                
            }
        })
        
    }, [currentSelect])

    const selectN2 = (event:React.ChangeEvent<HTMLSelectElement>) =>{
        setCurrentSelect(event.target.value)
    }

    return(
        <>
        {
            <select className="N2select hibSelect" onChange={selectN2}>
                {
                    selectsData &&
                    selectsData.map(
                        (item:string, index:number)=>
                        <option key={"option_"+index} value={item}>
                            {item == "%"?"全部":item} 共{counts && counts[item].toString()}件
                        </option>
                    )
                }
            </select>
        }
        {
            noticeData ?
            <NoticeTable rowData={noticeData}/>:
            <Loading />
            
        }
        </>
    )
}

export default Notice_table